import axios from "axios";
import store from "redux/Store";
import { v4 as uuidv4 } from "uuid";
import {
  __getMessageId,
  __getNotes,
  __getStatus,
  getCtagOnAddTrack,
} from "../../_clearance/utils/utils";
import { validateClearanceForm } from "../../util/validations/MlLicFormContentActionsValidation";
import { validateUniqueValue } from "util/validations/ClearanceWizardValidation";
import { deepCopyFunction, trimSearchQuery } from "util/CommonFunc";
import { pagingTotalRelation } from "redux/Types";

const reducerModule = "/mlLic/formcontent/";
export const actionTypes = {
  LOADING: "LOADING" + reducerModule,
  FORMS_LOADING: "FORMS_LOADING" + reducerModule,
  LOAD: "LOAD" + reducerModule,
  FORMS_LOAD: "FORMS_LOAD" + reducerModule,
  ERROR: "ERROR" + reducerModule,
  LOADING_TRACKS: "LOADING_TRACKS" + reducerModule,
  LOAD_TRACKS: "LOAD_TRACKS" + reducerModule,
  ERROR_TRACKS: "ERROR_TRACKS" + reducerModule,
  QUERY: "QUERY" + reducerModule,
  FOCUS_ITEM: "FOCUS_ITEM" + reducerModule,
  SELECT_ITEMS: "SELECT_ITEMS" + reducerModule,
  POSTING: "POSTING" + reducerModule,
  POST_OK: "POSTOK" + reducerModule,
  POST_ERROR: "POST_ERROR" + reducerModule,
  REMOVING_EP: "REMOVING_EP" + reducerModule,
  POST_PPL_ERROR: "POST_PPL_ERROR" + reducerModule,
  REFRESH_ITEMS: "REFRESH_ITEMS" + reducerModule,
  REFRESH_CF: "REFRESH_CF" + reducerModule,
  EDITING: "EDITING" + reducerModule,
  OPENWIZARD: "OPENWIZARD" + reducerModule,
  OPEN_BATCHCF_WIZARD: "OPEN_BATCHCF_WIZARD" + reducerModule,
  CLEAR_ERRORS: "CLEAR_ERRORS" + reducerModule,
  LOAD_HISTORY: "LOAD_HISTORY" + reducerModule,
  REMOVE_HISTORY: "REMOVE_HISTORY" + reducerModule,
  REMOVE_HISTORY_ALL: "REMOVE_HISTORY_ALL" + reducerModule,
  PREVIEW_TAB: "PREVIEW_TAB" + reducerModule,

  VALIDATING: "VALIDATING" + reducerModule,
  VALIDATING_OK: "VALIDATING_OK" + reducerModule,
  VALIDATING_ERROR: "VALIDATING_ERROR" + reducerModule,

  LOAD_CFTRACKS: "LOAD_CFTRACKS" + reducerModule,
  LOADING_CFTRACKS: "LOADING_CFTRACKS" + reducerModule,
  LOAD_ADDEPISODES: "LOAD_ADDEPISODES" + reducerModule,
  LOADING_ADDEPISODES: "LOADING_ADDEPISODES" + reducerModule,
  LOADING_ADDTRACKSTOEPISODES: "LOADING_ADDTRACKSTOEPISODES" + reducerModule,
  LOAD_ADDTRACKSTOEPISODES: "LOAD_ADDTRACKSTOEPISODES" + reducerModule,
  SET_TLOOKUP: "SET_TLOOKUP" + reducerModule,
  EPISODE_LIST: "EPISODE_LIST" + reducerModule,
  UPDATE_TRACK_METADATA: "UPDATE_TRACK_METADATA" + reducerModule,
  CLEAR_TRACKS: "CLEAR_TRACKS" + reducerModule,
  UPDATE_TRACK_USAGE: "UPDATE_TRACK_USAGE" + reducerModule,

  TRACK_STATES: "TRACK_STATES" + reducerModule,
  TOGGLE_COPY_TRACKS_DIALOG: "TOGGLE_COPY_TRACKS_DIALOG" + reducerModule,
  ADD_COPIED_TRACKS_TO_FORM: "ADD_COPIED_TRACKS_TO_FORM" + reducerModule,
  TRIGGER_FETCH_EPISODES: "TRIGGER_FETCH_EPISODES" + reducerModule,
  ADD_TRACK_DIALOG_OPEN: "ADD_TRACK_DIALOG_OPEN" + reducerModule,
  UPDATE_PRS_DATA: "UPDATE_PRS_DATA" + reducerModule,
  LAST_REFRESH: "LAST_REFRESH" + reducerModule,
  CLOSE_POPUP_ON_REFRESH: "CLOSE_POPUP_ON_REFRESH" + reducerModule,
  BLOCK_REFRESH_POPUP: "BLOCK_REFRESH_POPUP" + reducerModule,
  NOTIFICATION : "NOTIFICATION" + reducerModule,
  LICINFO_DOWNLOADING : "LICINFO_DOWNLOADING" + reducerModule,
  LICINFO_DOWNLOADED : "LICINFO_DOWNLOADED" + reducerModule,
  LICINFO_DOWNLOAD_ERROR : "LICINFO_DOWNLOAD_ERROR" + reducerModule,
  CLEARANCE_DOWNLOADING : "CLEARANCE_DOWNLOADING" + reducerModule,
  CLEARANCE_DOWNLOADED : "CLEARANCE_DOWNLOADED" + reducerModule,
  CLEARANCE_DOWNLOAD_ERROR : "CLEARANCE_DOWNLOAD_ERROR" + reducerModule,
};

export const updatePrsData = (id,data) => (dispatch) => {
  dispatch({
    type: actionTypes.UPDATE_PRS_DATA,
    id:id,
    payload: data,
  });
};

export const getCFContent = (id) =>
  new Promise(function (resolve, reject) {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    axios
      .get(`${orgID}/mllic/formcontent/${id}`, {
        headers: { orgid: orgID },
      })
      .then((res) => {
        resolve(res?.data?.results ? res.data.results : null);
      })
      .catch((err) => {
        resolve(null);
      });
  });

export const openWizard = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.OPENWIZARD,
    payload: data,
  });
};

export const setTrackStates = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.TRACK_STATES,
    payload: deepCopyFunction(data),
  });
};
export const openAddTrackDialog = (open = true, isEditCustomTrack = false, editCustomTrackDetails = null) => (dispatch) => {
  dispatch({
    type: actionTypes.ADD_TRACK_DIALOG_OPEN,
    payload: { open, isEditCustomTrack, editCustomTrackDetails },
  });
};

export const openBatchClearanceWizard = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.OPEN_BATCHCF_WIZARD,
    payload: data,
  });
};

export const setTlookUp = (data,ids) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_TLOOKUP,
    payload: data,
    ids:ids
  });
};

export const removeTrackHistory = (cfId, trackId) => (dispatch) => {
  dispatch({
    type: actionTypes.REMOVE_HISTORY,
    payload: {
      cfId:cfId, 
      trackId:trackId
    },
  });
};

export const removeTrackHistoryAll = (cfId) => (dispatch) => {
  dispatch({
    type: actionTypes.REMOVE_HISTORY_ALL,
    payload: {
      cfId:cfId, 
    },
  });
};

export const clearCFTracks = () => (dispatch) => {
  dispatch({
    type: actionTypes.CLEAR_TRACKS,
    payload: {},
  });
};

export const getTrackHistory = (cfId, trackId, done = null) => (dispatch) => {
  //   if (done) done({}, null);
  // }
  const {
    user: {
      credentials: { orgID },
    },
    mllicformcontent: { editing, items }, 
    clearanceRuntime: { runtime }
  } = store.getState();
  const tId = uuidv4();

  // dispatch({
  //   type: actionTypes.POSTING,
  //   payload: message,
  // });
  let migratedConvertedTrack = items?.find(d=>d.trackDetails.id == trackId);
  if(editing && editing[runtime?._config?.MIGRATED_FLAG]){
    let data = editing?.tracks?.find(d=>d.trackDetails.id == trackId)?.skyTrackClerenceHistory ?? [];
    dispatch({
      type: actionTypes.LOAD_HISTORY,
      payload: {
        cfId: cfId, 
        trackId:trackId,
        history: data.sort((a, b) => {
          const dateA = new Date(a.dateCreated);
          const dateB = new Date(b.dateCreated);
          return dateB - dateA;
        })
      }
    });
    if (done) done(data, null);
    return 
  }
  else if((migratedConvertedTrack && migratedConvertedTrack.hybrid)){
    let data = migratedConvertedTrack?.skyTrackClerenceHistory ?? [];
    dispatch({
      type: actionTypes.LOAD_HISTORY,
      payload: {
        cfId: cfId, 
        trackId:trackId,
        history: data.sort((a, b) => {
          const dateA = new Date(a.dateCreated);
          const dateB = new Date(b.dateCreated);
          return dateB - dateA;
        })
      }
    });
    if (done) done(data, null);
    return 
  }
  axios
    .post(`${orgID}/mllic/tracks/searchHistory`, { cfId: cfId, trackId: trackId }, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      //if (res.data.tid === tId) {
      dispatch({
        type: actionTypes.LOAD_HISTORY,
        payload: {
          cfId: cfId, 
          trackId:trackId,
          history:res.data
        }
      });

      if (done) done(res.data, null);
      //}
    })
    .catch((err) => {
      // dispatch({
      //   type: actionTypes.POST_ERROR,
      //   // payload: { e: err },
      //   payload: err.response?.data || { e: (err.message ? err.message : "Error in creating or updating. please retry") },
      // });

      // if (done) done(null, err.response?.data?.name == 'Duplicate Name'?err.response?.data?.name:err.message || "error");
    });
};

export const postItem = (action, message, items, done = null, refreshCFTracks = false) => async (dispatch) => {
  const tId = uuidv4();
  dispatch({
    type: actionTypes.POSTING,
    payload: {
      message: message,
      action: action,
      tId: tId,
    },
  });
  if(action === 'saveformClose')action = 'saveform';
  if (action === 'saveform') {
    let errors = await validateClearanceForm(items.cf);

    if (errors) {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: errors
      });
      if (done) done(null, errors);
      return;
    }
    if(items.cf.fieldsToValidate){
      delete items.cf.fieldsToValidate;
    }
  }

  const {
    user: {
      credentials: { orgID },
    },
    mllicformcontent: {
      query,
    },
  } = store.getState();

  axios
    .post(`${orgID}/mllic/forms/${action}`, items, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      //if (res.data.tid === tId) {
      dispatch({
        type: actionTypes.POST_OK,
        payload:items,
        tId: tId,
      });
      if (action === "removetracks" || (action === 'saveform' && items.cf.addToEpisodeData) || action === 'override'){
        dispatch({
          type: actionTypes.TRIGGER_FETCH_EPISODES,
          payload: null,
        });
      }

      if (done) done(res.data, null);

      if (action === 'saveform' || action === 'override') {
        let savedCfItems = {...items};
        if(refreshCFTracks){
          dispatch(searchCfItems(query));
          dispatch({
            type: actionTypes.TRIGGER_FETCH_EPISODES,
            payload: null,
          });
        }
        if (action === 'override') {
          const { mllicformcontent: { editing } } = store.getState();
          savedCfItems['cf'] = editing;
          savedCfItems['isOverride'] = true;
          dispatch(searchCfItems(query));
        }
        dispatch(checkCollisions(savedCfItems));
      }

      //}
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        // payload: { e: err },
        payload: err.response?.data || {
          e: err.message
            ? err.message
            : "Error in creating or updating. please retry",
        },
      });

      if (done) done(null, err);
    });
};

export const checkCollisions = (savedCfItems, cfRuntime = null) => (dispatch) => {

  const { 
    clearanceRuntime: { runtime },
    mllicformcontent: { editing, items }, 
  } = store.getState();

  if(!cfRuntime) cfRuntime = {...runtime};
  
  let clearedTrackList = [];
  let shouldCheck = false;

  // check if the CF type is promo or sport
  if (cfRuntime?._config?.CLEARANCE_FORM_TYPE 
    && cfRuntime?._config?.COLLISIONS
    && savedCfItems?.cf?.clearanceFormType 
    && cfRuntime?._config?.COLLISIONS?.cfType?.length
    &&  cfRuntime?._config?.COLLISIONS?.cfType.findIndex(c => c === savedCfItems?.cf?.clearanceFormType) !== -1) {

    // check and filter the "cleared" tracks in the CF
    if (savedCfItems?.cf?.clearance?.props?.length && cfRuntime?._config?.COLLISIONS.cfTrackStatus) {
      // check if admin override
      if(savedCfItems.isOverride){
        if(savedCfItems.status && !isNaN(savedCfItems.status) && +savedCfItems.status === cfRuntime?._config?.COLLISIONS.cfTrackStatus && savedCfItems?.tracks?.length){
          clearedTrackList = savedCfItems.tracks;
          shouldCheck = true;
        }
      }else{
        let clearedTracs = savedCfItems.cf.clearance.props.filter(p => p.id === "status" && (!isNaN(p.v) && +p.v === cfRuntime?._config?.COLLISIONS.cfTrackStatus)) || [];
  
        if(clearedTracs.length){
          // to check collision for all cleared tracks. 
          clearedTrackList = clearedTracs.map(c => { return c.trackId });
          shouldCheck = true;
        }
      }
    }
  }

  if(clearedTrackList.length){
    let collisionData = {
      tracks : clearedTrackList.map(d=>editing.clearance.trackSequence && editing.clearance.trackSequence[d]?editing.clearance.trackSequence[d]:d),
      txDates : savedCfItems?.cf.txDates ?? [],
      cfType: savedCfItems.cf.clearanceFormType,
      cfId: savedCfItems.cf.id
    }

    const {
      user: {
        credentials: { orgID },
      }
    } = store.getState();

    axios
    .post(`${orgID}/mllic/tracks/checkCollisions`, collisionData, {
      headers: { orgid: orgID }
    })
    .then((res) => {
      let collisions = res.data;
      let tempCollisions = {};
      clearedTrackList.map(d=>{
        tempCollisions[d] = collisions[editing.clearance.trackSequence && editing.clearance.trackSequence[d]?editing.clearance.trackSequence[d]:d]
      })
      collisions = tempCollisions;
      if(items && items.length && collisions && Object.keys(collisions)?.length){
        let nItems = [...items];
        Object.keys(collisions).map(c => {
          let nItemIndex = nItems.findIndex(n => n.trackDetails?.id === c)
          if(nItemIndex > -1){
            let nItem = nItems[nItemIndex];
            let isCollision = collisions[c] > 0 ? true : false;
            
            nItem = { ...nItem, collision : isCollision}
            nItems.splice(nItemIndex, 1, nItem);
          }
        });
        
        dispatch(refreshitems(nItems))
      }
    })
    .catch((err) => {});

  }

};

export const loadCollisions = (trackId, cf, done = null) => (dispatch) => {  

  if(trackId && cf){
    let collisionData = {
      tracks : [trackId].map(d=>cf.clearance.trackSequence && cf.clearance.trackSequence[d]?cf.clearance.trackSequence[d]:d),
      txDates : cf.txDates ?? [],
      cfType: cf.clearanceFormType,
      cfId: cf.id
    }

    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    axios
    .post(`${orgID}/mllic/tracks/loadCollisions`, collisionData, {
      headers: { orgid: orgID }
    })
    .then((res) => {
      let collisions = [];
      if(done && res.data && res.data[cf.clearance.trackSequence && cf.clearance.trackSequence[trackId]?cf.clearance.trackSequence[trackId]:trackId]){
        collisions = res.data[cf.clearance.trackSequence && cf.clearance.trackSequence[trackId]?cf.clearance.trackSequence[trackId]:trackId]
        done(collisions, null);
      };
    })
    .catch((err) => {
      if(done)done(null,err);
    });

  }

};

export const getSeriesMasterEpisodes = (masterFormId, done = null) => (dispatch) => {  
  const {
    user: {
      credentials: { orgID },
    },
    mllicformcontent: { editing },
    clearanceRuntime: { runtime }
  } = store.getState();

  axios
  .post((runtime?._config?.MIGRATED_FLAG && editing[runtime?._config?.MIGRATED_FLAG])?`${orgID}/mllic/formcontent/migrated/episodes`:`${orgID}/mllic/formcontent/episodes`, {
    masterFormId:  (runtime?._config?.MIGRATED_FLAG && editing[runtime?._config?.MIGRATED_FLAG])?(editing?.mlData?.skyMasterRef?editing?.mlData?.skyMasterRef:editing?.mlData?.mlCFId):masterFormId
  }, {
    headers: { orgid: orgID }
  })
  .then((res) => {
    dispatch({
      type: actionTypes.EPISODE_LIST,
      payload: res.data
    })
    done(res.data, null);
  })
  .catch((err) => {
    if(done)done(null,err);
  });

};

export const getCFTrackMetadata = (trackIds, done = null) => (dispatch) => {  
  const {
    user: {
      credentials: { orgID },
    },
    mllicformcontent: { editing, selectedItem },
    clearanceRuntime: { runtime }
  } = store.getState();

  if(editing?.clearance?.tLookup?.length > 0){
    let tLookup = editing.clearance.tLookup;
    let tIds = tLookup.map(t=>t.id);
    trackIds = trackIds.filter(t=>!tIds.includes(t));
    if(trackIds.length === 0){
      if(done)done(true, null);
      return;
    }
  }

  axios.post(`${orgID}/mllic/formcontent/tracks/metadata`, {
    trackIds: trackIds.map(d=>editing?.clearance?.trackSequence && editing?.clearance?.trackSequence[d] ? editing?.clearance?.trackSequence[d] : (editing?.programmeType === runtime?._config?.PROGRAMME_TYPES?.EPISODE && selectedItem ? selectedItem.trackDetails.skyMlId : d))
  }, {
    headers: { orgid: orgID }
  })
  .then((res) => {
    let data = [];
    trackIds.map(nId=>{
      let track = res.data.find(d=>d.id === (editing?.clearance?.trackSequence && editing?.clearance?.trackSequence[nId] ? editing?.clearance?.trackSequence[nId] : (editing?.programmeType === runtime?._config?.PROGRAMME_TYPES?.EPISODE && selectedItem ? (selectedItem.trackDetails?.skyMlId || nId) : nId)))
      if(track){
        data.push({
          ...track, 
          skyMlId: track.id, 
          id: nId, 
        })
      }
    })
    dispatch({
      type: actionTypes.UPDATE_TRACK_METADATA,
      payload: data
    })
    done(res.data, null);
  })
  .catch((err) => {
    if(done)done(null,err);
  });

};

export const getCFTrackEpisodes = (data, done = null) => (dispatch) => {  
  const {
    user: {
      credentials: { orgID },
    },
    mllicformcontent: { editing }
  } = store.getState();

  axios
  .post(`${orgID}/mllic/formcontent/tracks/trackepisodes`, data, {
    headers: { orgid: orgID }
  })
  .then((res) => {
    done(res.data, null);
  })
  .catch((err) => {
    if(done)done(null,err);
  });

};

export const refreshitems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.REFRESH_ITEMS,
    payload: items,
  });
};

export const refreshEdit = (editing, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.EDITING,
    payload: editing,
  });

  if(done)done();
};

export const updateTrackUsage = (trackId, trackUsage, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.UPDATE_TRACK_USAGE,
    payload: {
      trackId: trackId, 
      trackUsage: trackUsage
    },
  });

  if(done)done();
};

export const clearEpisodeList = (episodeList = [], done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.EPISODE_LIST,
    payload: episodeList,
  });

  if(done)done();
};

export const refreshCF = (cf, newTracks=[]) => (dispatch) => {


  const {
    mllicformcontent: {
      editing: { clearance: { tLookup} },
      query,
    },
    orgRuntime: {
      runtime: {
        _trackFields: _trackFields,
    
      }
    }
  } = store.getState();

  // newTracks.forEach(v=>{
  //   tLookup.push(v);
  // })

  // let items = [];
  // cf.clearance.tracks.forEach(v => {
  //   let tDetails = tLookup.find(t=>t.id === v) || {};
  //   let tStatus = __getStatus(cf.clearance, tDetails.id) || { v: "", unconfirmed: true };
  //   let messageid = __getMessageId(cf.clearance, tDetails.id) || {
  //     v: "",
  //   };

  //   items.push({
  //     ...tDetails,
  //     origin: tDetails[_trackFields.musicOrigin.id],
  //     clearancestatus: tStatus.unconfirmed ? "" : tStatus.v,
  //     adminOverridden: tStatus.adminOverridden,
  //     adminOverriddenWithNotes: tStatus.adminOverriddenNotes,
  //     createdBy: tStatus.by,
  //     createdAt: tStatus.at,
  //     messageid: messageid.v,
  //     trackNotes: (__getNotes(cf.clearance, tDetails.id) || { v: [] }).v,
  //   });
  // });

  // cf.clearance.tLookup = tLookup;



  dispatch({
    type: actionTypes.REFRESH_CF,
    payload: { 
      data: cf, 
      // items: items
     },
  });

  let nQuery = {...query, page: 0, selectedMasterFormId: cf.selectedMasterFormId, clearanceFormId: cf.id}
  dispatch(setQuery(nQuery, ()=>{
    dispatch(searchCfItems(nQuery));
  }));
};

export const selectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_ITEMS,
    payload: items,
  });
};

export const focusItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.FOCUS_ITEM,
    payload: item,
  });
};

const _initCFItems = (res, done, dispatch) => {
  const {
    orgRuntime: {
      runtime: {
        _trackFields: _trackFields,
    
      }
    },
    mllicformcontent: { query }, 

  } = store.getState();
  let items = [];
  
  dispatch({
    type: actionTypes.LOAD,
    payload: { data: res, items: items },
  });

  let nQuery = {...query, selectedMasterFormId: res.selectedMasterFormId, clearanceFormId: res.id}
  dispatch(setQuery(nQuery, ()=>{
    dispatch(searchCfItems(nQuery));
  }));

  // res.clearance.tracks.map((v) => {
  //   let tDetails = res.clearance.tLookup.find((t) => t.id === v) || {};
  //   let status = __getStatus(res.clearance, tDetails.id) || {
  //     v: "",
  //   };
  //   let messageid = __getMessageId(res.clearance, tDetails.id) || { v: "" };
  //   items.push({
  //     ...tDetails,
  //     origin: tDetails[_trackFields.musicOrigin.id],
  //     clearancestatus: status.unconfirmed ? "" : status.v,
  //     adminOverridden: status.adminOverridden,
  //     adminOverriddenWithNotes: status.adminOverriddenNotes,
  //     trackNotes: (__getNotes(res.clearance, tDetails.id) || { v:[] }).v,
  //     messageid: messageid.v,
  //     createdBy: status.by,
  //     createdAt: status.at,
  //   });
  // });

  //return { data: res, items: items };
  // dispatch({
  //   type: actionTypes.LOAD,
  //   payload: { data: res, items: items },
  // });

  if (done) done({ data: res, items: items }, null);
};

export const loadcfWithClerance = (cf, done) => (dispatch) => {
  return _initCFItems(cf, done, dispatch);
};

export const search = (query) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  const tId = uuidv4();
  dispatch({
    type: actionTypes.FORMS_LOADING,
  });

  axios
    .post(`${orgID}/mllic/forms/search`, trimSearchQuery(query), {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.FORMS_LOAD,
          payload: res.data.results,
          total: res.data.total,
          totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err.message || "error" },
      });
    });
};

export const clearanceFormCopyTracks = (cfIds, done = null) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
    mllicformcontent: {
      query,
      editing
    },
    orgRuntime
  } = store.getState();
  const tId = uuidv4();
  axios
    .post(`${orgID}/mllic/formcontent/tracks/copytracks`, cfIds, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      let cfTracks = res.data?.cfTracks || []; 
      let trackSequence = res.data?.trackSequence || {}; 
      dispatch({
        type: actionTypes.ADD_COPIED_TRACKS_TO_FORM,
        payload: cfTracks,
      });
      if(cfTracks.length>0){
        dispatch(searchCfItems(query));
        getCtagOnAddTrack(cfTracks.map(d=>d.trackDetails.id), cfTracks, orgRuntime, trackSequence);
        dispatch({
          type: actionTypes.TRIGGER_FETCH_EPISODES,
          payload: null,
        });
        dispatch({
          type: actionTypes.REFRESH_CF,
          payload: { 
            data: {
              ...editing, 
              clearance: {
                ...editing.clearance, 
                tracks: [
                  ...editing.clearance.tracks, 
                  ...Object.keys(trackSequence)
                ], 
                trackSequence: {
                  ...editing.clearance.trackSequence, 
                  ...trackSequence
                }
              }
            }, 
          },
        });
      }
      if(done){
        done(cfTracks, null);
      }
    })
    .catch((err) => {
      if(done){
        done(null, err);
      }
    });
};

export const clearanceFormCopySelectedTracks = (cfForm, done = null) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
    mllicformcontent: {
      query,
      editing
    },
    orgRuntime
  } = store.getState();
  const tId = uuidv4();
  axios
    .post(`${orgID}/mllic/formcontent/tracks/copyselectedtracks`, cfForm, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      let cfTracks = res.data?.cfTracks || []; 
      let trackSequence = res.data?.trackSequence || {}; 
      dispatch({
        type: actionTypes.ADD_COPIED_TRACKS_TO_FORM,
        payload: cfTracks,
      });
      if(cfTracks.length>0){
        dispatch(searchCfItems(query));
        getCtagOnAddTrack(cfTracks.map(d=>d.trackDetails.id), cfTracks, orgRuntime, trackSequence);
        dispatch({
          type: actionTypes.TRIGGER_FETCH_EPISODES,
          payload: null,
        });
        dispatch({
          type: actionTypes.REFRESH_CF,
          payload: { 
            data: {
              ...editing, 
              clearance: {
                ...editing.clearance, 
                tracks: [
                  ...editing.clearance.tracks, 
                  ...Object.keys(trackSequence)
                ], 
                trackSequence: {
                  ...editing.clearance.trackSequence, 
                  ...trackSequence
                }
              }
            }, 
          },
        });
      }
      if(done){
        done(cfTracks, null);
      }
    })
    .catch((err) => {
      if(done){
        done(null, err);
      }
    });
};

export const toggleCopyTracksDialog = (open = false) => (dispatch) => {
  dispatch({
    type: actionTypes.TOGGLE_COPY_TRACKS_DIALOG,
    payload: open,
  });
};

export const clearErrors = (param = "", done) => (dispatch) => {

  const {
    mllicformcontent: { posting },
    clearanceRuntime: { runtime }
  } = store.getState();
  
  if(param && posting.errors){
    let headerq = runtime && runtime._config && runtime._config?.CF_HEADER_FIELD_LIST?.filter(f => f.id === param) || [];

    if(posting.errors[param]){
      delete posting.errors[param];
    }

    if (headerq.length > 0 && headerq[0].subQuestions && headerq[0].subQuestions.length > 0) {
      headerq[0].subQuestions.forEach(e => {
        delete posting.errors[e.id];
      });
    }

    dispatch({
      type: actionTypes.CLEAR_ERRORS,
      payload: { ...posting.errors },
    });
  }
  else if (!param) {
    dispatch({
      type: actionTypes.CLEAR_ERRORS,
      payload: {},
    });
  }

  if (done) done();
};

export const loadcf = (id, done = null) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  const tId = uuidv4();
  dispatch({
    type: actionTypes.LOADING,
  });

  axios
    .get(`${orgID}/mllic/formcontent/${id}`, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        return _initCFItems(res.data.results, done, dispatch);
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err },
      });
      if (done) done(null, err);
    });
};


export const loadcfBackground = (id, done = null) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  const tId = uuidv4();
  // dispatch({
  //   type: actionTypes.LOADING,
  // });

  axios
    .get(`${orgID}/mllic/formcontent/${id}`, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.TRIGGER_FETCH_EPISODES,
          payload: null,
        });
        return _initCFItems(res.data.results, done, dispatch);
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err },
      });
      if (done) done(null, err);
    });
};

export const closePopupOnRefresh = (shouldOpenPrompt = false) => (dispatch) => {
  dispatch({
    type: actionTypes.CLOSE_POPUP_ON_REFRESH,
    payload: shouldOpenPrompt,
  });
}

export const setBlockRefresh = (block = false, shouldSearch= false) => (dispatch) => {
  const {
    mllicformcontent: {
      editing,
    },
  } = store.getState();
  dispatch({
    type: actionTypes.BLOCK_REFRESH_POPUP,
    payload: block,
  });

  if(!block && shouldSearch){
    if(editing.id) dispatch(loadcfBackground(editing.id));
  }
}

export const setLastRefresh = (lastRefreshed) => (dispatch) => {
  dispatch({
    type: actionTypes.LAST_REFRESH,
    payload: lastRefreshed,
  });
}

export const setNotificationIds = (id) => (dispatch) => {
  dispatch({
    type: actionTypes.NOTIFICATION,
    payload: id,
  });
}

export const setFocusPreview = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.PREVIEW_TAB,
    payload: data,
  });
};

export const addTracKToPPL = (message, items, done = null) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();

  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });

  axios
    .post(`${orgID}/mllic/forms/addtoppl`, items, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      dispatch({
        type: actionTypes.POST_OK,
        payload: items
      });

      if (done) done(res.data, null);

    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_PPL_ERROR,
        // payload: err.response?.data?.e || err.message ? err.message : "Error adding track to PPL.",
        payload: err.response?.data?.e || "Error adding track to PPL.",
      });

      setTimeout(() => {
        dispatch({
          type: actionTypes.POST_ERROR,
          payload: err.response?.data || {
            e: err.message
              ? err.message
              : "Error adding track to PPL.",
          },
        });
      }, 1500);

      if (done) done(null, err);
    });
};

export const checkUniqueValue = (field, value, cfId, done = null) => async (dispatch) => {

  dispatch({
    type: actionTypes.VALIDATING,
    payload: "Validating...",
  });

  let isUnique = await validateUniqueValue(field, value, cfId) ?? false;

  if (isUnique) {
    clearErrors(field.id);
    dispatch({
      type: actionTypes.VALIDATING_OK,
    });

  } else {
    dispatch({
      type: actionTypes.VALIDATING_ERROR,
      payload: { [field.id]: `${field.label} already in use` },
    });
  }
}

export const getCFTrackData = (cfId, track, done = null) => (dispatch) => {

  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();

  dispatch({
    type: actionTypes.LOADING_CFTRACKS,
  });

  axios
    .post(`${orgID}/mllic/formcontent/tracks`, { cfId: cfId, tracks: [track] }, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      dispatch({
        type: actionTypes.LOAD_CFTRACKS,
        payload: {
          cfId: cfId,
          trackId: track,
          cfTrackData: (res.data && res.data.length > 0 ? res.data[0] : {})
        }
      });
      if (done) done(res.data, null);
    })
    .catch((err) => {

    });
};

export const getCFAddEpisodes = (episodeList, done = null) => (dispatch) => {

  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();

  dispatch({
    type: actionTypes.LOADING_ADDEPISODES,
  });

  axios
    .post(`${orgID}/mllic/formcontent/addepisodes`, { episodeList: episodeList }, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      dispatch({
        type: actionTypes.LOAD_ADDEPISODES,
        payload: {}
      });
      if (done) done(res.data, null);
    })
    .catch((err) => {
      if (done) done(null, err);
      dispatch({
        type: actionTypes.LOAD_ADDEPISODES,
        payload: {}
      });
    });
};

export const getCFAddTracksToEpisodes = (data, done = null) => (dispatch) => {

  const {
    user: {
      credentials: { orgID },
    },
    mllicformcontent: {
      query,
    },
  } = store.getState();
  const tId = uuidv4();

  dispatch({
    type: actionTypes.LOADING_ADDTRACKSTOEPISODES,
  });

  axios
    .post(`${orgID}/mllic/formcontent/addtrackstoepisodes`, data, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      dispatch({
        type: actionTypes.LOAD_ADDTRACKSTOEPISODES,
        payload: {}
      });
      dispatch({
        type: actionTypes.TRIGGER_FETCH_EPISODES,
        payload: null,
      });
      dispatch(searchCfItems(query));
      if (done) done(res.data, null);
    })
    .catch((err) => {
      if (done) done(null, err);
      dispatch({
        type: actionTypes.LOAD_ADDTRACKSTOEPISODES,
        payload: {}
      });
    });
};

export const updateLicensingInfo = (data, done = null) => (dispatch) => {

  const {
    user: {
      credentials: { orgID },
    }, 
    mllicformcontent: {
      query,
    },
  } = store.getState();
  const tId = uuidv4();

  dispatch({
    type: actionTypes.POSTING,
    payload: {
      message: "Updating Licensing Info...",
    }
  });

  axios
    .post(`${orgID}/mllic/formcontent/tracks/updatelicensinginfo`, data, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      dispatch({
        type: actionTypes.POSTING,
        payload: {
          message: "Updated Licensing Info"
        }
      });
      dispatch(searchCfItems(query));
      setTimeout(() => {
        dispatch({
          type: actionTypes.POST_OK,
        })
      }, 1500);
      if (done) done(res.data, null);
    })
    .catch((err) => {
      if (done) done(null, err?.response?.data || err);
      setTimeout(() => {
        dispatch({
          type: actionTypes.POST_ERROR,
          payload: "Error updating Licensing Info",
        });
      }, 1500);
    });
};

export const downloadLicensingInfo = (data, done = null) => (dispatch) => {

  const {  user: { credentials: { orgID } } } = store.getState();
  const tId = uuidv4();
  
  dispatch({
    type: actionTypes.LICINFO_DOWNLOADING,
    payload: "Downloading Licensing Info..."
  });

  if( !data?.trackId || !data?.clearanceFormId){
    setTimeout(() => {
      dispatch({
        type: actionTypes.LICINFO_DOWNLOAD_ERROR,
        payload: "Error Downloading Licensing Info - Missing Data",
      });
    }, 1500);
  }

  axios
    .post(`${orgID}/mllic/formcontent/tracks/downloadlicensinginfo`, data, {
      headers: { tid: tId, orgid: orgID },
      responseType: "blob",
    })
    .then((res) => {
      dispatch({
        type: actionTypes.LICINFO_DOWNLOADED,
      })
      if (done) done(res.data, null);
    })
    .catch((err) => {
      if (done) done(null, err?.response?.data || err);

      setTimeout(() => {
        dispatch({
          type: actionTypes.LICINFO_DOWNLOAD_ERROR,
          payload: "Error downloading Licensing Info",
        });
      }, 1500);
    });
};

export const downloadClearanceInfo = (data, done = null) => (dispatch) => {

  const {  user: { credentials: { orgID } } } = store.getState();
  const tId = uuidv4();
  
  dispatch({
    type: actionTypes.CLEARANCE_DOWNLOADING,
    payload: "Downloading Clearance Form Info...",
  });

  if(!data?.clearanceFormId){
    setTimeout(() => {
      dispatch({
        type: actionTypes.CLEARANCE_DOWNLOAD_ERROR,
        payload: "Error Downloading Clearance Form Info",
      });
    }, 1500);
  }

  axios
    .post(`${orgID}/mllic/formcontent/downloadClearanceInfo`, data, {
      headers: { tid: tId, orgid: orgID },
      responseType: "blob",
    })
    .then((res) => {
      dispatch({
        type: actionTypes.CLEARANCE_DOWNLOADED,
      })
      if (done) done(res, null);
    })
    .catch((err) => {
      if (done) done(null, err?.response?.data || err);

      dispatch({
        type: actionTypes.CLEARANCE_DOWNLOADING,
        payload: "Error Downloading Clearance Form Info",
      });
      setTimeout(() => {
        dispatch({
          type: actionTypes.CLEARANCE_DOWNLOAD_ERROR,
          payload: "Error Downloading Clearance Form Info",
        });
      }, 1500);
    });
};

export const getCFGroups = (type, action, cfType) =>
  new Promise(function (resolve, reject) {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();
    
    axios
      .post(`${orgID}/mllic/getCfGroups`, 
      { groupType : type, action : action, cfType: cfType },
      { headers: { orgid: orgID },})
      .then((res) => {
        resolve(res?.data ? res.data : []);
      })
      .catch((err) => {
        resolve(null);
      });
  });

export const getCFEpisodes = (cfId) =>
  new Promise(function (resolve, reject) {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    axios
      .post(`${orgID}/mllic/getcfepisodecount`, 
      { cfId: cfId },
      { headers: { orgid: orgID },})
      .then((res) => {
        resolve(res?.data ? res.data : "");
      })
      .catch((err) => {
        resolve(null);
      });
  });

export const cfRemoveEpisode = (episodeList, masterFormId, done = null) => (dispatch) => 
  new Promise(function (resolve, reject) {
    dispatch({
      type: actionTypes.REMOVING_EP,
      payload: {
        removingEpisode: true, 
        message: "Removing Episode...",
      }
    });
    
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    axios
      .post(`${orgID}/mllic/formcontent/removeepisodes`, 
      { 
        episodeList: episodeList, 
        masterFormId: masterFormId
      },
      { headers: { orgid: orgID },})
      .then((res) => {
        dispatch({
          type: actionTypes.REMOVING_EP,
          payload: {
            removingEpisode: true, 
            message: "Episode Removed Successfully",
          }
        })
        setTimeout(() => {
          dispatch({
            type: actionTypes.REMOVING_EP,
            payload: {
              removingEpisode: false, 
              message: ""
            },
          });
        }, 1500);
        if(done){
          done(res?.data, null);
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.REMOVING_EP,
          payload: {
            removingEpisode: true, 
            message: "Error removing Episode"
          },
        });
        setTimeout(() => {
          dispatch({
            type: actionTypes.REMOVING_EP,
            payload: {
              removingEpisode: false, 
              message: ""
            },
          });
        }, 1500);
        if(done){
          done(null, err);
        }
      });
  });

export const setQuery = (query, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.QUERY,
    payload: query,
  });

  if (done) done();
};

export const searchCfItems = (query) => (dispatch) =>{

  const {
    user: {
      credentials: { orgID },
    },
    orgRuntime: {
      runtime: {
        _trackFields: _trackFields,
    
      }
    },
    mllicformcontent: { query : { page, size, trackIds : qTrackIds, selectedEpisode}, editing, query },
    clearanceRuntime: { runtime }
  } = store.getState();


  dispatch({
    type: actionTypes.LOADING_TRACKS,
  });

  
  axios
  .post(editing[runtime?._config?.MIGRATED_FLAG]?`${orgID}/mllic/formcontent/migrated/tracks/search`:`${orgID}/mllic/formcontent/tracks/search`, query, {
    headers: { orgid: orgID }
  })
  .then((res) => {

    //reorder clearance tracks if there are replaced tracks
    if((editing.clearanceFormType === runtime?._config?.CLEARANCE_FORM_TYPE?.PROGRAMMING || editing.clearanceFormType === runtime?._config?.CLEARANCE_FORM_TYPE?.NEWS) && editing.clearance.replacedTracks){
      const replacedTracks = editing.clearance.replacedTracks;
      const resultList = res.data.results || [];
      const newOrder = [];
      const movedIndexes = new Set();
  
      for (let i = 0; i < resultList.length; i++) {
        const currentItem = resultList[i];
        const currentTrackId = currentItem.trackDetails?.id;
        if (movedIndexes.has(i) || Object.values(replacedTracks).includes(currentTrackId)) continue;

        if (currentTrackId && replacedTracks[currentTrackId]) {
          const replacementTrackId = replacedTracks[currentTrackId];

          const replacementIndex = resultList.findIndex((item, idx) => {
            return !movedIndexes.has(idx) && item.trackDetails?.id === replacementTrackId;
          });
  
          if (replacementIndex !== -1) {
            newOrder.push(resultList[replacementIndex], currentItem);
            movedIndexes.add(replacementIndex);
          }
        }else{
          newOrder.push(currentItem);
        }
      }
      res.data.results = newOrder;

    }



    dispatch({
      type: actionTypes.LOAD_TRACKS,
      payload: {
        items: res.data.results,
        totalItems: res.data.total
      }
    });

    dispatch(checkCollisions({cf: editing}));

  })
  .catch((err) => {
    dispatch({
      type: actionTypes.ERROR_TRACKS,
      payload: "Error loading Tracks.."
    });
  });

}
